export class Entity {
    uid;

    chunkSize = 16;

    name = "";
    type = "";

    position = {x: 0, y: 0, z: 0}

    rotation = {x: 0, y: 0, z: 0}

    scale = {x: 0, y: 0, z: 0}

    owner = "0x0";

    model_key = null; //Key of the model within model_manager

    /**
     * @deprecated - use Animator class instead
     * @type {{}}
     */
    animations = {
        //
    }

    actions = {
        //
    }

    lastActionAt;

    constructor(uid, type) {
        this.uid = uid;
        this.type = type;

        this.lastActionAt = Date.now();
    }

    setName(name) {
        this.name = name
    }

    isOwner(wallet_addr) {
        return this.owner === wallet_addr
    }

    setOwner(owner) {
        this.owner = owner
    }

    setPosition(position) {
        this.position = position
    }

    setRotation(rotation) {
        this.rotation = rotation
    }

    setScale(scale) {
        this.scale = scale
    }

    getScale() {
        return this.scale
    }

    getRotation() {
        return this.rotation
    }

    getPosition() {
        return this.position;
    }

    getID() {
        return this.uid
    }

    getType() {
        return this.type
    }

    getChunk() {
        return {
            x: Math.floor(this.position.x / this.chunkSize),
            z: Math.floor(this.position.z / this.chunkSize),
        }
    }

    setModelKey(key) {
        this.model_key = key
    }

    getModelKey() {
        return this.model_key
    }

    canMove() {
        return false //TODO override per ent
    }

    canAnimate() {
        return Object.keys(this.animations).length > 0
    }

    canInteract() {
        return this.actions.length > 0
    }

    getActions() {
        return Object.keys(this.actions)
    }

    canReach(pos) {
        return false
    }

    interact(key, data) {
        if (!this.actions[key])
            return null

        this.setLastActionAt()
        return this.actions[key](data)
    }

    registerAction(key, handler) {
        this.actions[key] = handler
    }

    //TODO work on this
    registerAnimation(key, handler) {
        this.animations[key] = handler
    }

    getAnimation(key) {
        return this.animations[key]
    }

    setLastActionAt(t = Date.now()) {
        this.lastActionAt = t
    }

    getLastActionAt() {
        return this.lastActionAt
    }

    print() {
        console.log(`${self.constructor.name}: ${this.uid} - ${this.type} ${this.name}`, {
            position: this.getPosition(),
            rotation: this.getRotation(),
            actions: this.getActions(),
            chunk: this.getChunk(),
        })
    }

    add(data) {
        // - STUB
    }

    /**
     * Called each frame if canAnimate = true
     * @param delta
     */
    animate(delta) {
        // - STUB
    }

    /**
     * Should be called to clean up any additional resources related to entity
     */
    remove() {
        // - STUB
    }

    /**
     * Basic property update
     * @param data
     */
    update(data) {
        const dataKeys = Object.keys(data)
        for (let key in dataKeys) {
            console.log("Entity::update", this.uid, key, dataKeys[key], data[dataKeys[key]])
            this[dataKeys[key]] = data[dataKeys[key]]
        }
    }
}